export enum Info {
  Init = 'linkchat.sdk.initProps',
  ImcloudConfig = 'imcloud.init.config',
  GetToken = 'linkchat.sdk.getToken',
  AuthError = 'linkchat.sdk.authError',
  CreateDialogAsync = 'linkchat.sdk.CreateDialogAsync',
  CreateDialogError = 'linkchat.sdk.CreateDialogError',
  CreateDialogLow = 'linkchat.sdk.CreateDialogLow',
}

export enum DeleyInfo {
  SendMessage = 'send.text.message',
  SendFileMessage = 'send.file.message',
}
export enum HttpInfo {
  CreateDialog = 'http.create.dialog',
  TransferAgent = 'http.transfer.agent',
}

export enum ImcloudInfo {
  SdkInitSuccess = 'imcloud.sdk.init.success',
  SdkInitFail = 'imcloud.sdk.init.fail',
  WebSocketDisconnected = 'imcloud.sdk.ws.WebSocketDisconnected',
  WebSocketConnected = 'imcloud.sdk.ws.WebSocketConnected',
  ConversationChange = 'imcloud.sdk.ws.ConversationChange',
  WsError = 'imcloud.sdk.ws.Error',
  ReceiveNewMessage = 'imcloud.sdk.ReceiveNewMessage',
  SendMessageError = 'imcloud.sdk.SendMessageError',
  SendFileMessageError = 'imcloud.sdk.SendFileMessageError',
  /** 用户侧首屏消息渲染时间 */
  MessageRender = 'imcloud.sdk.MessageRenderDur',
  InitLoadPage = 'imcloud.sdk.InitLoadPage',
}
